import {
  GET_ALL_MENU_LOAD,
  GET_ALL_MENU_SUCCESS,
  GET_ALL_MENU_ERROR,
  BULK_UPLOAD_LOADING,
  BULK_UPLOAD_SUCCESS,
  BULK_UPLOAD_ERROR,
  BULK_UPLOAD_RESET,
  UPDATE_ITEM_LOAD,
  UPDATE_ITEM_SUCCESS,
  UPDATE_ITEM_ERROR,
  UPDATE_ITEM_RESET,
  BULK_UPLOAD_LOADING_PARTNER,
  BULK_UPLOAD_SUCCESS_PARTNER,
  BULK_UPLOAD_ERROR_PARTNER,
  BULK_UPLOAD_RESET_PARTNER,
} from "../../actions/types";

export const getAllMenuReducer = (
  state = { isAllMenuLoading: true, isMenuLoaded: false },
  action: any
) => {
  switch (action.type) {
    case GET_ALL_MENU_LOAD:
      return {
        isAllMenuLoading: true,
        isMenuLoaded: false,
        menuItems: [],
      };
    case GET_ALL_MENU_SUCCESS:
      return {
        isAllMenuLoading: false,
        isMenuLoaded: true,
        menuItems: action.payload,
      };
    case GET_ALL_MENU_ERROR:
      return {
        isAllMenuLoading: false,
        error: action.payload,
        menuItems: [],
      };

    default:
      return state;
  }
};

export const bulkUploadReducer = (
  state = {
    isMenuUploaded: false,
    isMenuUploading: false,
    isUploadFailed: false,
  },
  action: any
) => {
  switch (action.type) {
    case BULK_UPLOAD_LOADING:
      return {
        isMenuUploaded: false,
        isMenuUploading: true,
        isUploadFailed: false,
      };
    case BULK_UPLOAD_SUCCESS:
      return {
        isMenuUploaded: true,
        isMenuUploading: false,
        status: action.payload,
        isUploadFailed: false,
      };
    case BULK_UPLOAD_ERROR:
      return {
        isMenuUploaded: false,
        isMenuUploading: false,
        isUploadFailed: true,
        error: action.payload,
      };
    case BULK_UPLOAD_RESET:
      return {
        isMenuUploaded: false,
        isMenuUploading: false,
        isUploadFailed: false,
        error: {},
        status: {},
      };

    default:
      return state;
  }
};

export const bulkUploadPartnerReducer = (
  state = { isMenuUploaded: false, isMenuUploading: false },
  action: any
) => {
  switch (action.type) {
    case BULK_UPLOAD_LOADING_PARTNER:
      return {
        isMenuUploadedPartner: false,
        isMenuUploadingPartner: true,
      };
    case BULK_UPLOAD_SUCCESS_PARTNER:
      return {
        isMenuUploadedPartner: true,
        isMenuUploadingPartner: false,
        status: action.payload,
      };
    case BULK_UPLOAD_ERROR_PARTNER:
      return {
        isMenuUploadedPartner: false,
        isMenuUploadingPartner: false,
        error: action.payload,
      };
    case BULK_UPLOAD_RESET_PARTNER:
      return {
        isMenuUploadedPartner: false,
        isMenuUploadingPartner: false,
        error: {},
        status: {},
      };

    default:
      return state;
  }
};

export const updateMenuReducer = (
  state = { isMenuUpdated: false, isUpdating: false, updateFailed: false },
  action: any
) => {
  switch (action.type) {
    case UPDATE_ITEM_LOAD:
      return {
        isMenuUpdated: false,
        isUpdating: true,
        updateFailed: false,
      };
    case UPDATE_ITEM_SUCCESS:
      return {
        updatedItem: action.payload,
        isMenuUpdated: true,
        isUpdating: false,
        updateFailed: false,
      };
    case UPDATE_ITEM_ERROR:
      return {
        error: action.payload,
        isMenuUpdated: false,
        isUpdating: false,
        updateFailed: true,
      };
    case UPDATE_ITEM_RESET:
      return {
        isMenuUpdated: false,
        isUpdating: false,
        updateFailed: false,
        error: {},
        updatedItem: {},
      };

    default:
      return state;
  }
};
